module.exports = __webpack_public_path__ + "static/eiffage-a5f1413c2e6db3928c289d06357657ea.png";